// extracted by mini-css-extract-plugin
export default {"backgroundColor":"#f0f2f5"};